import React from 'react';
import { TextInput } from '../../../../components/TextInput';
import { PdfComponent } from '../../PdfComponent';
import { usePdfTemplateContext } from '../../PdfTemplateEditorContext';

interface PdfTemplateComponentSizeProps {
  component: PdfComponent;
}

export default function PdfTemplateComponentSize<T>({ component }: PdfTemplateComponentSizeProps) {
  const { updateComponent } = usePdfTemplateContext<T>();

  return (
    <div className='flex gap-2'>
      <TextInput
        value={component.width}
        label={'Width (mm)'}
        type={'number'}
        onChange={value => updateComponent(component.id, { width: Number(value) })}
      />

      <TextInput
        value={component.height}
        label={'Height (mm)'}
        type={'number'}
        onChange={value => updateComponent(component.id, { height: Number(value) })}
      />
    </div>
  );
}
